import React from 'react';
import './tab.scss';
export var Tab = function (_a) {
    var title = _a.title, children = _a.children;
    return React.createElement("div", { key: "tab-".concat(title) }, children);
};
